export class TrackerStudentPropertyModel {
	key: string;
	value: boolean;
	title: string;
	ui_editable: boolean;
}

export function TrackerStudentPropertyModel_ClassTransform_Type() {
	return TrackerStudentPropertyModel;
}
